import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs, useSitemap, useRequestData } from 'wsm-common-data';

import { inventoryCountsSelector } from '../../server/selectors';

import GridCard from '../cards/Grid';
import ShowMoreButton from '../ShowMoreButton';
import { getModelLink } from '../../utils/getModelLink';
import { useShowMore } from '../../hooks/useShowMore';

const GridContainer = ({ vehicles }) => {
	const prefs = usePrefs();
	const sitemap = useSitemap();
	const { displayStyle, modelCardGridPadding } = usePrefs();
	const { deviceType } = useRequestData();
	const inventoryCounts = useSelector(inventoryCountsSelector);

	const { vehiclesToDisplay, hasMore, buttonLabel, showMore } =
		useShowMore(vehicles);

	const { modelLinkAlias, modelLinkParameters, noInventoryFallbackUrl } =
		prefs;

	const containerClassnames = setClassNames([
		'model-card-grid-container',
		modelCardGridPadding
	]);

	const colClassNames = setClassNames([
		'col-xs-12',
		'col-sm-6',
		'col-md-6',
		'col-lg-4',
		'my-4',
		'px-4',
		'd-flex'
	]);

	const shouldRenderButton =
		deviceType === 'DESKTOP' && hasMore && displayStyle === 'grid';

	return (
		<>
			<div
				className={containerClassnames}
				data-testid="model-card-grid-container"
			>
				{React.Children.toArray(
					vehiclesToDisplay.map((vehicle, i) => {
						const cardKey = `${vehicle.gvBodyStyle
							.toLowerCase()
							.replace(/ /g, '-')}-${i}`;

						return (
							<div
								key={cardKey}
								id={`card-${i}`}
								className={colClassNames}
								data-testid="model-card-grid-container-vehicle"
							>
								<GridCard
									modelObject={vehicle}
									modelLink={getModelLink(
										`${sitemap.get(modelLinkAlias)}`,
										modelLinkParameters,
										vehicle,
										noInventoryFallbackUrl,
										inventoryCounts
									)}
								/>
							</div>
						);
					})
				)}
			</div>

			{shouldRenderButton && (
				<ShowMoreButton label={buttonLabel} onClick={showMore} />
			)}
		</>
	);
};

GridContainer.propTypes = {
	vehicles: PropTypes.arrayOf(
		PropTypes.shape({
			year: PropTypes.number,
			make: PropTypes.string,
			model: PropTypes.string,
			modelInv: PropTypes.string,
			gvBodyStyle: PropTypes.string,
			image: PropTypes.string,
			inventoryCount: PropTypes.number,
			minStartingAtPrice: PropTypes.number
		})
	).isRequired
};

export default GridContainer;
